__turbopack_context__.v({
  "icon": "fg22wW_icon",
});
